import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var OnboardingManagersNotificationsRoutes = {
    "/brand/:brand_id/managers-notifications": {
        "loginRequired": true,
        "name": "appLayout.harriSH.managers-notifications",
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../offer-templates/offer-templates.module.js");
                }
            }
        ]
    },

    [`/managers-notifications/${hmapPathParamRegex}`]: {
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "name": "appLayout.harriSH.access-portal.settings.managers-notifications",
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../offer-templates/offer-templates.module.js");
                }
            }
        ]
    }
};